












































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";
import { DataModules } from "@/store/modules/data";
import { IContractProduct } from "@/models/contracts";
import CProdMixin from "@/mixins/cProdMixin";
import Context from "@/mixins/context";
import _ from "@/boot/lodash";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "ticket-detail-cell": () =>
      import("@/components/app/global/tickets/ticketDetailCell.vue")
  }
})
export default class TicketHeaderProductDetail extends Mixins(
  CProdMixin,
  Context
) {
  // Inject

  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;

  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;

  // Computed

  public get ticketData() {
    return this.$ticketData();
  }

  public get cProd() {
    return _.get(this.ticketData, "contractProduct");
  }

  public get cProdIdentifier() {
    return this.getProductName(this.cProd);
  }

  public get cProdRoute() {
    return {
      name: this.isAdmin
        ? "adminClientCProdQuickLookModal"
        : this.isMockClientContext
        ? "admin__upmindClientCProd"
        : ClientRoutes.CONTRACT_PRODUCT,
      params: {
        contractId: this.cProd.contract_id,
        productId: this.cProd.id,
        ...(this.isAdmin
          ? {
              clientId: this.ticketData.ticket.client_id,
              cProdIdentifier: this.cProdIdentifier
            }
          : {})
      }
    };
  }

  public updateContractProductId(id: string | null = null) {
    this.$ticketMethods.updateTicket({
      contract_product_id: id
    });
  }

  public openSelectProductModal() {
    this.$store.dispatch(
      `data/${DataModules.CONTRACTS}/openSelectClientProductModal`,
      {
        props: {
          accountId: this.ticketData.ticket.account_id
        },
        events: {
          success: ({ id }: IContractProduct) =>
            this.updateContractProductId(id)
        }
      }
    );
  }
}
